<template>
  <div class="detail-infos-wrap">
    <MultipleFilter
      :options="filterOptions"
      @chacked="mutipleChacked"
      @closeTag="handlecloseTag"
    ></MultipleFilter>
    <div class="body-content-wrap">
      <div class="tableCard">
        <div class="spin-wrap" v-if="loading">
          <a-spin :spinning="loading" />
        </div>
        <Empty v-if="isEmpty" class="empty-wrap"></Empty>
        <div v-if="!isEmpty && !loading">
          <TableCard
            :tableList="talentList"
            @moreChange="moreChange"
          ></TableCard>
        </div>

        <Pagination
          :total="total"
          @pageChange="handleChange"
          :pageSize="params.pageSize"
        ></Pagination>
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from '@/components/common/Pagination'
import MultipleFilter from '@/components/MultipleFilter'
import Empty from '@/components/common/Empty/index'
import { filterOptions } from './config'
import mixinsBackStack from '@/views/backstageSupport/mixins'
import { getTeamDataList } from '@/api/MTalentData.js'
import { mapGetters, mapMutations } from 'vuex'
import TableCard from '@/components/common/tableCard'
export default {
  mixins: [mixinsBackStack],
  data() {
    return {
      keywords: '', // 检索关键词
      goodsInfos: [],
      filterOptions, // 多选过滤
      params: {
        pageSize: 6,
        pageNum: 1,
        status: 1
      },
      total: 0,
      body: {},
      loading: false,
      isEmpty: false,
      talentList: []
    }
  },
  components: {
    MultipleFilter,
    TableCard,
    Pagination,
    Empty
  },
  watch: {
    headSearchValueResult: {
      handler() {
        this.initParams()
        this.initDefaultValue()
      },
      immediate: true
    }
  },
  computed: {
    ...mapGetters('headerSearch', ['headSearchValueResult'])
  },
  methods: {
    ...mapMutations('headerSearch', ['updateTabValue']),
    // 初始化关键词、请求体
    initParams() {
      this.keywords = this.headSearchValueResult

      // this.body = {
      //   patentName: this.headSearchValueResult
      // }
    },
    // 初始化方法
    async initDefaultValue() {
      try {
        this.loading = true
        const data = await getTeamDataList({ ...this.params, ...this.body })
        this.total = data.total
        this.talentList = data.rows
        this.isEmpty = data.rows.length === 0
        this.talentList.forEach(item => {
          item.img = this.getUrl(item)
        })
      } catch (error) {
        this.$apiStatusHandler(99, error.message)
      } finally {
        this.loading = false
      }
    },
    mutipleChacked(result) {
      const datas = {}
      Object.keys(result).forEach(key => {
        const data = result[key]
        if (Object.keys(data).length === 0) return
        const {
          instance: { prop },
          value,
          name
        } = data
        if (prop === 'price' && value !== '') {
          const v = value.split('-')
          datas['params'] = { minPrice: v[0], maxPrice: v[1] }
        } else if (prop === 'price' && value == '') {
          const start = name.slice(5)
          const end = start.split('-')
          datas['params'] = { minPrice: end[0], maxPrice: end[1] }
        } else {
          datas[prop] = value
        }
      })

      this.body = datas
      this.initDefaultValue()
    },
    // 多选tag处理
    handlecloseTag(result) {
      const datas = {}
      Object.keys(result).forEach(key => {
        const data = result[key]
        if (Object.keys(data).length === 0) return
        const {
          instance: { prop },
          value,
          name
        } = data
        if (prop === 'price' && value !== '') {
          const v = value.split('-')
          datas['params'] = { minPrice: v[0], maxPrice: v[1] }
        } else if (prop === 'price' && value == '') {
          const start = name.slice(5)
          const end = start.split('-')
          datas['params'] = { minPrice: end[0], maxPrice: end[1] }
        } else {
          datas[prop] = value
        }
      })
      this.body = datas
      this.initDefaultValue()
    },
    // 切换页面
    handleChange(e) {
      this.params.pageNum = e
      this.initDefaultValue()
    },
    moreChange(val) {
      this.$router.push({
        name: 'TechnicalTeamDetail',
        query: { id: val.id }
      })
    },
    getUrl(item) {
      if (item.fileVo !== null && item.fileVo.length > 0) {
        return item.fileVo[0].filePath
      } else {
        return ''
      }
    }
  },
  destroyed() {
    // 重置vuex中的tab值
    this.updateTabValue({ key: 'result', value: '' })
  }
}
</script>
